import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { isEmpty, uniqBy } from 'lodash';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { months, shortenandHoverString } from '../../../Components/helper';
import ExpandedViewForProductAttribute from './ExpandedviewForProductAttribute';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function BottomProductAttributeTableRows({
  item,
  i,
  onSelectCheckBox,
  selectedIdArray,
  hanldeUpdate,
  handleDelete,
  expandGrandTotalChild,
  parentIndexes,
  array,
  subbrandAccess,
}) {
  const ProductTestingData = useSelector((redState) => redState);
  const { UserDetails, BOMConfigDetails, Measuremets, SuppliersDetails } = ProductTestingData;
  const { isSupplierLoggedIn } = UserDetails;
  const { ProductColourList } = Measuremets;
  const { isProductArchived } = BOMConfigDetails;
  const { tier2AndAboveList, tier1List } = SuppliersDetails;
  const [supplierOptions, setSupplierOptions] = useState([]);
  const { t } = useTranslation('common');

  useEffect(() => {
    const suppArray = [...tier1List, ...tier2AndAboveList];
    const upnewArr = uniqBy(suppArray, (e) => e._id);
    setSupplierOptions([...upnewArr]);
  }, [tier2AndAboveList, tier1List]);

  const checkBox = (ele) => {
    return (
      !isSupplierLoggedIn &&
      !isProductArchived && (
        <td className=" text-left">
          {item?.expandData?.length <= 1 && (
            <div className="common-checkbox">
              <input
                onChange={(e) => onSelectCheckBox(e, ele?.idPlusSupplierId || ele?._id)}
                name={`checking_${ele?.idPlusSupplierId || ele?._id}`}
                id={`checking_${ele?.idPlusSupplierId || ele?._id}`}
                type="checkbox"
                checked={selectedIdArray?.some((val) => val === ele?.idPlusSupplierId || val === ele?._id || val === ele?.expandData?.[0]?.idPlusSupplierId)}
              />
              <label htmlFor={`checking_${ele?.idPlusSupplierId || ele._id}`} className="chklabel" />
            </div>
          )}
        </td>
      )
    );
  };

  const showCreatedModifiedBy = () => {
    return (
      <button type="button" className="btn p-0 m-0">
        <div className="info-container ml-0">
          <i className="icon-Information f-20" />
          <div className="info-content m-0">
            <p className="m-0 text-left">
              <strong>{t('FILTER.CREATED')}</strong> : {item?.createdBy?.firstName && `${item?.createdBy?.firstName} ${item?.createdBy?.lastName} | `}
              {moment(item?.createdAt).format('DD-MMMM-YYYY, h:mm a')}
            </p>
            {item?.modifiedBy?.firstName && (
              <p className="text-left m-0">
                <strong>{t('PROGRESS_INDICATOR.MODIFI')}</strong> : {item?.modifiedBy && `${item?.modifiedBy?.firstName} ${item?.modifiedBy?.lastName} | `}
                {moment(item?.updatedAt).format('DD-MMMM-YYYY, h:mm a')}
              </p>
            )}
          </div>
        </div>
      </button>
    );
  };

  const actionButtons = (ele) => {
    return (
      <>
        <CustomTooltip placement="top" tooltipText={t('FILTER.UPDATE')}>
          <button type="button" className="btn p-0" onClick={() => hanldeUpdate(ele)} aria-label="update">
            <i className="icon-Update-1 f-20" />
          </button>
        </CustomTooltip>
        {showCreatedModifiedBy()}
        <CustomTooltip placement="top" tooltipText={t('TAKING_DATES.DELETES')}>
          <button className="btn p-0" type="button" aria-label="delete" onClick={() => handleDelete(ele._id)}>
            <i className="icon-Delete f-20" />
          </button>
        </CustomTooltip>
      </>
    );
  };

  const statuSet = (ele) => {
    switch (ele?.currentStatus?.quality) {
      case 'true':
      case 'green':
      case 'Approved':
        return (
          <>
            <span>{ele.currentStatus.quality ? ele?.currentStatus?.quality : 'Approved'}</span>
            <span className="col-status right approved" />
          </>
        );

      case 'false':
      case 'red':
      case 'Rejected':
        return (
          <>
            <span>{ele.currentStatus.quality ? ele?.currentStatus?.quality : 'Rejected'}</span>
            <span className="col-status right rejected" />
          </>
        );

      case 'gray':
        return (
          <>
            <span>{ele.currentStatus.quality ? ele?.currentStatus?.quality : 'No Quality Status'}</span>
            <span className="col-status right deleted" />
          </>
        );

      default:
        return (
          <>
            <span>{t('TAKING_DATES.PENDING')}</span>
            <span className="col-status right pending" />
          </>
        );
    }
  };

  const statusCalled = (ele) => {
    return ele?.currentStatus?.status ? (
      statuSet(ele)
    ) : (
      <>
        <span>{t('TAKING_DATES.PENDING')}</span>
        <span className="col-status right pending" />
      </>
    );
  };

  const statuColourSet = (ele) => {
    switch (ele?.currentStatus?.colour) {
      case 'true':
      case 'green':
      case 'Approved':
        return (
          <>
            <span>{ele.currentStatus.colour ? ele.currentStatus.colour : 'Approved'}</span>
            <span className="col-status right approved" />
          </>
        );

      case 'false':
      case 'red':
      case 'Rejected':
        return (
          <>
            <span>{ele.currentStatus.colour ? ele.currentStatus.colour : 'Rejected'}</span>
            <span className="col-status right rejected" />
          </>
        );

      case 'gray':
        return (
          <>
            <span>{ele.currentStatus.colour ? ele.currentStatus.colour : 'No Colour Status'}</span>
            <span className="col-status right deleted" />
          </>
        );

      default:
        return (
          <>
            <span>{t('FILTER.PENDINGS')}</span>
            <span className="col-status right pending" />
          </>
        );
    }
  };

  const statusColourCalled = (ele) => {
    return ele?.currentStatus?.status ? (
      statuColourSet(ele)
    ) : (
      <>
        <span>{t('FILTER.PENDINGS')}</span>
        <span className="col-status right pending" />
      </>
    );
  };

  const forSupps = () => {
    return item?.expandData?.length > 1 ? 'Multiple' : item?.suppliers[0]?.name;
  };
  const componentSupplierConfirmation = () => {
    let compSuppsName = '';
    Array.isArray(item?.colourRefsData) &&
      item?.colourRefsData?.forEach((ele) => {
        if (ele?.tier1Supplier === item?.suppliers[0]?._id && ele?.colourWayId === item?.colourLibraries[0]?._id) {
          supplierOptions?.forEach((colourElement) => {
            if (colourElement?._id === ele?.componentSupplier) {
              compSuppsName = colourElement?.name;
            }
          });
        }
      });
    if (item.componentSupp) {
      compSuppsName = Array.isArray(item.componentSupp) ? item.componentSupp.map((ele) => ele?.supplierName).join(', ') : item.componentSupp;
    }
    return !isEmpty(compSuppsName) ? compSuppsName : '-';
  };

  const forCompSupps = () => {
    return item?.expandData?.length > 1 ? 'Multiple' : componentSupplierConfirmation();
  };
  const colourRefConfirmation = () => {
    let colourName = '';
    const supplierIds = item?.suppliers.map((ele) => ele?._id);
    const colourIds = item?.colourLibraries.map((ele) => ele?._id);
    Array.isArray(item?.colourRefsData) &&
      item?.colourRefsData?.forEach((ele) => {
        const checkFoundSupplier = ele?.colourRefsDataAsPerSuppliers?.find((vl) => supplierIds.includes(vl?.tier1Supplier));
        if (checkFoundSupplier && colourIds.includes(ele?.colourWayId)) {
          ProductColourList?.forEach((colourElement) => {
            const checkFoundCol = ele?.colourRefsDataAsPerSuppliers?.find((vl) => colourElement?._id === vl?.colourRef);
            if (checkFoundCol) {
              colourName = colourElement?.name;
            }
          });
        }
      });
    return !isEmpty(colourName) ? colourName : '-';
  };

  const forColourRef = () => {
    return item?.expandData?.length > 1 ? 'Multiple' : colourRefConfirmation();
  };
  // changes KJ

  const colourConformation = () => {
    let colourRefs = '';
    const supplierIds = item?.suppliers.map((ele) => ele?._id);
    const colourIds = item?.colourLibraries.map((ele) => ele?._id);
    Array.isArray(item?.colourRefsData) &&
      item?.colourRefsData?.forEach((ele) => {
        const checkFoundSupplier = ele?.colourRefsDataAsPerSuppliers?.find((vl) => supplierIds.includes(vl?.tier1Supplier));
        if (checkFoundSupplier && colourIds.includes(ele?.colourWayId)) {
          ProductColourList?.forEach((colourElement) => {
            const checkFoundCol = ele?.colourRefsDataAsPerSuppliers?.find((vl) => colourElement?._id === vl?.colourRef);
            if (checkFoundCol) {
              colourRefs = ProductColourList.find((ele) => ele?._id === checkFoundCol?.colourRefName)?.name;
            }
          });
        }
      });
    return !isEmpty(colourRefs) ? colourRefs : '-';
  };

  const forColourConf = () => {
    return item?.expandData?.length > 1 ? 'Multiple' : colourConformation();
  };

  const forColourways = () => {
    return item?.expandData?.length > 1 ? 'Multiple' : item?.colourLibraries[0]?.name;
  };

  const handleMonths = (ele) => {
    const mnth = months.filter((obj) => obj._id === ele?.month);
    return !isEmpty(mnth) && mnth[0].name;
  };

  const expands = () => {
    return item.isExpanded ? (
      <button className="btn-up-down" onClick={() => expandGrandTotalChild(i)} type="button" aria-label="expand">
        <span className="icon-new-down-arrow-icon f-32 icon-inverse" />
      </button>
    ) : (
      <button className="btn-up-down" onClick={() => expandGrandTotalChild(i)} type="button" aria-label="collapse">
        <span className="icon-new-down-arrow-icon f-32" />
      </button>
    );
  };

  const match = () => {
    return item?.isMatch ? 'Yes' : 'No';
  };

  const tableData = () => {
    return item?.isExpanded ? (
      <ExpandedViewForProductAttribute
        expandedData={item?.expandData}
        hanldeUpdate={hanldeUpdate}
        showCreatedModifiedBy={showCreatedModifiedBy}
        handleDelete={handleDelete}
        statusCalled={statusCalled}
        statusColourCalled={statusColourCalled}
        selectedIdArray={selectedIdArray}
        onSelectCheckBox={onSelectCheckBox}
        supplierOptions={supplierOptions}
        expandGrandTotalChild={expandGrandTotalChild}
        parentIndexes={parentIndexes}
        item={array}
        subbrandAccess={subbrandAccess}
      />
    ) : (
      <tr key={i}>
        {checkBox(item)}
        <td>{item?.expandData && item?.expandData?.length > 1 && expands()}</td>
        <td className="text-left first-fix-col">
          <div>
            <span className="product-bom-ref">
              <a
                href={`${window.location.origin}/development-order/${item?._id}/bom`}
                target="_blank"
                className="text-black product-name-underline"
                rel="noopener noreferrer"
              >
                {item?.number}
              </a>
            </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{shortenandHoverString(item?.description, 50)}</span>
          </div>
        </td>{' '}
        <td className="text-left">
          <div>
            <span>{forSupps()} </span>
          </div>
        </td>{' '}
        <td className="text-left">
          <div>
            <span>{forCompSupps()} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{item?.brandId?.name} </span>
          </div>
        </td>
        {subbrandAccess && (
          <td className="text-left">
            <div>
              <span>{item?.subBrandId?.name || '-'} </span>
            </div>
          </td>
        )}
        <td className="text-left">
          <div>
            <span>{item?.seasonId?.name} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{handleMonths(item)} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{item?.year} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{item?.catOneId?.name} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{item?.catTwoId?.name} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{item?.catThreeId?.name} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{item?.catFourId?.name} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{item?.size}</span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{item?.weight}</span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{item?.quantity}</span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{item?.statusId?.name} </span>
          </div>
        </td>
        <td className="text-left">
          <div>{forColourways()}</div>
        </td>
        <td className="text-left">
          <div>
            <span>{forColourRef()} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{forColourConf()}</span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{(isEmpty(item?.expandData) || item?.expandData?.length === 1) && match()}</span>
          </div>
        </td>
        <td className="text-left last-fix-col">
          {(isEmpty(item?.expandData) || item?.expandData?.length === 1) && (
            <div>
              <strong>{t('FILTER.QUALITIES')}</strong> {statusCalled(item)}
              <br />
              <strong>{t('FILTER.COLOUR')}</strong> {statusColourCalled(item)}
            </div>
          )}
        </td>
        <td className="text-right">
          <div className="action-btns new-listing-action d-flex justify-content-end align-items-center">
            {(isEmpty(item?.expandData) || item?.expandData?.length === 1) && actionButtons(item)}
          </div>
        </td>
      </tr>
    );
  };

  return <>{tableData()}</>;
}

export default BottomProductAttributeTableRows;
